// @flow

import React from 'react';
import { useTranslation } from 'react-i18next';

import {
    PictureInPictureExitIcon,
    PictureInPictureInIcon
} from '../base/icons';
import { CircularLabel } from '../base/label';
import { Tooltip } from '../base/tooltip';


// type Props = AbstractProps & {
//     /**
//      * The message to show within the label.
//      */
//     _labelKey: string,

//     /**
//      * The message to show within the label's tooltip.
//      */
//     _tooltipKey: string,

//     /**
//      * The redux representation of the MHTrack displayed on large video.
//      */
//     _videoTrack: Object,
// };

/**
 * React {@code Component} responsible for displaying a label that indicates
 * the displayed video state of the current conference. {@code AudioOnlyLabel}
 * Will display when the conference is in audio only mode. {@code HDVideoLabel}
 * Will display if not in audio only mode and a high-definition large video is
 * being displayed.
 */
const PictureInPictureLabel = props => {
    const { _isPictureInPictureVisible, onClickedLabel } = props;
    const { t } = useTranslation();

    return (
        <Tooltip
            content = {
                _isPictureInPictureVisible
                    ? t('voicecommand.inActivePIPLabel')
                    : t('voicecommand.activePIPLabel')
            }
            position = { 'left' }>
            <CircularLabel
                className = 'vc'
                icon = {
                    _isPictureInPictureVisible
                        ? PictureInPictureExitIcon
                        : PictureInPictureInIcon
                }
                onClick = { () => onClickedLabel(!_isPictureInPictureVisible) } />
        </Tooltip>
    );
};

export default PictureInPictureLabel;
